import _get from 'lodash/get';

import videoFeedTypes from './videoFeedTypes';

const { REEL } = videoFeedTypes;

const getShareContentType = (mediaPlayback) => {

    const feedType = _get(mediaPlayback, 'feeds[0].type');

    return feedType === REEL ? feedType.toLowerCase() : 'video';

};

export default getShareContentType;
